import { IndicatorStatuses } from "../services/http/component/models/IndicatorStatuses";

export function copyToClipboard(string: string) 
{
    const textarea = document.createElement("textarea");
    textarea.value = string;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
}

export function stringToCurrency(string: string): string
{
    let currency;
    let regexp = /(\d)(?=(\d{3})+(?!\d))/g;
    currency = `$${string.replace(regexp, "$1,")}`

    return currency;
}

export function getColorVariantClassname(status: number): string
{
    switch (status)
    {
        case IndicatorStatuses.FullyFunctional: return "functional";
        case IndicatorStatuses.Warning: return "warning";
        case IndicatorStatuses.Critical: return "critical";
        case IndicatorStatuses.SystemFailure: return "failing";
        default: return "offline";
    }
}

export function getColorVariables(status: number): string
{
    const styles = getComputedStyle(document.documentElement);

    switch (status)
    {
        case IndicatorStatuses.FullyFunctional: return styles.getPropertyValue("--functional-color");
        case IndicatorStatuses.Warning: return styles.getPropertyValue("--warning-color");
        case IndicatorStatuses.Critical: return styles.getPropertyValue("--critical-color");
        case IndicatorStatuses.SystemFailure: return styles.getPropertyValue("--failing-color");
        default: return styles.getPropertyValue("--offline-color");
    }
}

export function className(...classNames: any): { className: string }
{
    const classes = [];
    for (const className of classNames)
    {
        if (typeof className === "object")
        {
            for (const key in className)
            {
                if (className.hasOwnProperty(key) && className[key])
                {
                    classes.push(key);
                }
            }
        } else
        {
            classes.push(className);
        }
    }
    return { className: classes.join(" ") };
}

export function capitalize(string: string): string
{
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function clamp(min: number, max: number, value: number): number
{
    return Math.max(min, Math.min(max, value));
}

export function addZero(x: number): string
{
    return String(x).padStart(2, "0");
}